export default __webpack_public_path__ + "static/media/Build7.f76c67db.jpg";